var map = {
	"./abstrato-1-thumb.jpg": 168,
	"./abstrato-2-thumb.jpg": 169,
	"./abstrato-3-thumb.jpg": 170,
	"./abstrato-4-thumb.jpg": 171,
	"./abstrato-5-thumb.jpg": 172,
	"./abstrato-6-thumb.jpg": 173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 420;